<template>
  <div>
    <div class="sh-pop-sub-tit">실시간 인기검색어
      <ul class="sh-pop-sub-nav">
        <li v-for="(data, index) in tabList" :key="index">
          <button :class="selectClass(index)" @click="setTabPage(index)">{{data.name}}</button>
        </li>
      </ul>
    </div>
    <div v-if="tabDataList" class="search-popup-scroll">
      <ul class="sh-pop-list01">
        <li v-for="(data, index) in tabDataList" :key="index">
          <a href="#" @click.prevent="goSearchDetail(data.searchkeyword)"><span class="popup-rank">{{(index+1)}}</span> {{data.displaykeywords}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getSearchPopularKeywords } from '@/common/utils/request'
import _ from 'lodash'
import { CLOSE_SEARCH_POPUP_EVENT } from '@/common/resources/const'
import cookie from '@/common/utils/cookie'
import { PATH_NAME_SEARCH } from '@/common/resources/router.const'
export default {
  props: {
    isplayymovie: {
      type: String,
      default: 'y'
    }
  },
  data () {
    return {
      tabIndex: 0,
      tabType: 'vod',
      tabDataList: [],
      index: 0,
      tabList: [
        { key: 'vod', name: 'VOD' },
        { key: 'live', name: 'LIVE' },
        { key: 'movie', name: '영화' }
      ],
      pooqzoneType: cookie.getPooqZoneType()
    }
  },
  methods: {
    setTabList () {
      this.tabList = this.isplayymovie === 'n' ? _.filter(this.tabList, tab => tab.key !== 'movie') : this.tabList
    },
    selectClass (index) {
      return index === this.tabIndex ? 'col-white' : ''
    },
    setData () {
      getSearchPopularKeywords({ contenttype: this.tabType }).then(({ data }) => {
        this.tabDataList = _.get(data, 'list', [])
      })
    },
    setTabPage (index) {
      this.tabIndex = index
      this.tabType = this.tabList[index].key
      this.setData()
    },
    goSearchDetail (searchWord) {
      this.$events.$emit(CLOSE_SEARCH_POPUP_EVENT)
      this.$router.push({
        name: PATH_NAME_SEARCH,
        query: {
          category: this.tabType,
          searchWord: searchWord
        }
      })
    }
  },
  created () {
    this.setTabList()
    this.setTabPage(this.tabIndex)
  }
}
</script>
<style lang="css" src="@/assets/css/search.css"></style>
